import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // <-- Path yang benar
import { useAuth } from '../context/AuthContext';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaSpinner, FaExclamationTriangle } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AdminLoginPage.css';
import logo from '../assets/logo.svg';

const AdminLoginPage = () => {
    const { currentUser } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Cek pesan dari state navigasi (misal: setelah login berhasil)
        if (location.state?.message) {
            toast.success(location.state.message);
            // Hapus state dari lokasi agar notifikasi tidak muncul lagi saat refresh
            navigate(location.pathname, { replace: true, state: {} });
        }

        // Cek pesan dari sessionStorage (misal: setelah logout)
        const logoutMessage = sessionStorage.getItem('logoutMessage');
        if (logoutMessage) {
            toast.success(logoutMessage);
            sessionStorage.removeItem('logoutMessage'); // Hapus setelah ditampilkan agar tidak muncul lagi
        }
    }, [location, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!email || !password) {
            setError('Email dan password harus diisi.');
            setLoading(false);
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/admin/dashboard', { state: { message: 'Login berhasil! Selamat datang.' } });
        } catch (err) {
            // Memberikan pesan error yang lebih spesifik
            let errorMessage = 'Gagal login. Silakan periksa kredensial Anda.';
            if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                errorMessage = 'Email atau password yang Anda masukkan salah.';
            } else if (err.code === 'auth/too-many-requests') {
                errorMessage = 'Terlalu banyak percobaan login. Coba lagi nanti.';
            }
            setError(errorMessage);
            console.error("Firebase login error:", err);
        } finally {
            setLoading(false);
        }
    };

    // Jika pengguna sudah login, tampilkan pesan dan tombol untuk kembali ke dashboard
    if (currentUser) {
        return (
            <div className="login-container">
                <div className="login-box" style={{ textAlign: 'center' }}>
                    <img src={logo} alt="SMK Sumbangsih Logo" className="login-logo" />
                    <h2>Anda Sudah Login</h2>
                    <p>Anda sudah masuk sebagai {currentUser.email}.</p>
                    <button onClick={() => navigate('/admin/dashboard')} className="login-button" style={{ marginTop: '20px' }}>
                        Kembali ke Dashboard
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="login-box">
                <div className="login-header">
                    <img src={logo} alt="SMK Sumbangsih Logo" className="login-logo" />
                    <h2>Login Admin Panel</h2>
                    <p>Silakan masuk untuk melanjutkan!</p>
                </div>
                <form onSubmit={handleLogin} className="login-form">
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <div className="input-wrapper">
                            <FaEnvelope className="input-icon" />
                            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Masukkan Email" required />
                        </div>
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-wrapper">
                            <FaLock className="input-icon" />
                            <input type={showPassword ? "text" : "password"} id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Kata Sandi" required />
                            <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>
                    {error && <div className="error-message">
                        <FaExclamationTriangle /> <span>{error}</span>
                    </div>}
                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? <><FaSpinner className="spinner" /> Sedang Masuk...</> : 'Login'}
                    </button>
                </form>
                <Link to="/" className="back-to-home-link">
                    &larr; Kembali ke Beranda
                </Link>
            </div>
        </div>
    );
};

export default AdminLoginPage;